import React, { useContext, useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useSuggestionsService, STATES } from '@bingads-webui-campaign-react/simplified-sign-up-suggestions';

import { SuggestionsContext } from './suggestions-context';
import { useLoadBISuggestions } from './services/use-load-bi-suggestions';
import { useLoadTargetsSuggestions } from './services/use-load-target-suggestions';

function SuggestionsContextInt(props) {
  const {
    updateValue,
  } = props;

  const { loadBISuggestions } = useLoadBISuggestions();
  const { loadTargetsSuggestions } = useLoadTargetsSuggestions();

  const {
    state,
    send,
  } = useSuggestionsService({
    loadBISuggestions,
    loadTargetsSuggestions,
  });

  const {
    isRSADone,
    isImagesDone,
    isTargetsDone,
    isBIDone,
    allDone,
  } = state.context.flags;
  const {
    rsa,
    images,
    targets,
    bi,
  } = state.context.outputs;

  const isInitState = state.matches(STATES.INIT);

  const value = useMemo(() => ({
    isRSADone,
    isImagesDone,
    isTargetsDone,
    isBIDone,
    allDone,
    rsa,
    images,
    targets,
    bi,
    send,
    isInitState,
  }), [allDone, bi, images, isBIDone, isImagesDone, isInitState, isRSADone, isTargetsDone, rsa, send, targets]);

  useEffect(() => {
    updateValue(value);
  }, [updateValue, value]);

  return null;
}

SuggestionsContextInt.propTypes = {
  updateValue: PropTypes.func.isRequired,
};

export function SuggestionsContextProvider(props) {
  const {
    children,
  } = props;

  const { scope } = useContext(ScopeContext);
  const { aid } = scope.values;
  const [value, updateValue] = useState({});

  return (
    <SuggestionsContext.Provider value={value}>
      {children}
      {aid &&
        <SuggestionsContextInt
          updateValue={updateValue}
        />
      }
    </SuggestionsContext.Provider>
  );
}

SuggestionsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
